module.exports = __webpack_public_path__ + "assets/img/9cdf-kr.svg";